export class Slide {
  id:number;
  titre:any;
  image:string;
}
